import { Directive, ElementRef, OnInit } from '@angular/core';
import Inputmask from 'inputmask';

@Directive({
  standalone: false,
  selector: '[thousandsSeparators]',
})
export class ThousandsSeparatorsDirective implements OnInit {
  constructor(private el: ElementRef) {}

  ngOnInit() {
    if (this.el.nativeElement.value !== 'Mixte') {
      Inputmask('decimal', {
        radixPoint: ',',
        placeholder: '',
        autoGroup: true,
        groupSeparator: ' ',
        groupSize: 3,
        autoUnmask: true,
      }).mask(this.el.nativeElement);
    }
  }
}
